import Showdown from 'showdown';

export const converter = new Showdown.Converter({
    tables: true,
    simplifiedAutoLink: true,
    excludeTrailingPunctuationFromURLs: true,
    strikethrough: true,
    disableForced4SpacesIndentedSublists: true,
    underline: true,
    simpleLineBreaks: true,
});
